module.exports = __webpack_public_path__ + "img/typeother.3775ba2a.png";